import { Typography } from '@mui/material';
import { getCompanyValidationForLoggingIn } from 'lib/api/express';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { showAlert } from 'lib/functions/utils';
import PruffConnectBillingPortal from 'pages/PruffConnect/Billing';
import AutoEnrollment from 'pages/PruffConnect/Common/AutoEnrollment';
import WaitingForAuthorization from 'pages/PruffConnect/Common/WaitingForAuthorization';
import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import PruffConnectLayout from './layouts/PruffConnect';
import PruffConnectHome from './pages/PruffConnect';
import Credit from './pages/PruffConnect/Credit';
import Factoring from './pages/PruffConnect/Factoring';
import Settings from './pages/PruffConnect/Settings';
import SGR from './pages/PruffConnect/SGR';
import { RootState } from './services/redux/store';

const PruffConnectRoutes: React.FC = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [canLogIn, setCanLogIn] = useState(false);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const ShortLayout = (props: { children: React.ReactNode }) => {
    const { children } = props;
    return (
      <div>
        <PruffConnectLayout>{children}</PruffConnectLayout>
      </div>
    );
  };
  if (!auth.user?.clientId)
    return (
      <Typography variant="h1">
        No se ha encontrado el cliente. Reinicia tu navegador
      </Typography>
    );

  const validateIfCompanyIsAuthorized = async () => {
    try {
      setLoading(true);
      if (!auth.user?.clientId)
        return showAlert(dispatch, 'error', 'Contacta a la empresa');
      const response = await getCompanyValidationForLoggingIn(
        dispatch,
        auth.user?.clientId,
      );
      setCanLogIn(response.canLogIn);
      setIsEnrolled(response.isEnrolled);
      setLoading(false);
    } catch (error) {
      console.error('Error validating company authorization:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    void validateIfCompanyIsAuthorized();
  }, []);

  if (loading) return <CenteredCircularProgress />;
  if (!canLogIn) {
    if (!isEnrolled) {
      return (
        <div>
          <AutoEnrollment addLoguot />
        </div>
      );
    } else {
      return (
        <div>
          <WaitingForAuthorization />
        </div>
      );
    }
  }

  return (
    <div>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <ShortLayout>
                <PruffConnectHome />
              </ShortLayout>
            }
          />
          <Route
            path="/factoring/:page"
            element={
              <ShortLayout>
                <Factoring />
              </ShortLayout>
            }
          />
          <Route
            path="/sgr"
            element={
              <ShortLayout>
                <SGR />
              </ShortLayout>
            }
          />
          <Route
            path="/credit"
            element={
              <ShortLayout>
                <Credit />
              </ShortLayout>
            }
          />
          <Route
            path="/billing"
            element={
              <ShortLayout>
                <PruffConnectBillingPortal />
              </ShortLayout>
            }
          />
          <Route
            path="/settings"
            element={
              <ShortLayout>
                <Settings />
              </ShortLayout>
            }
          />
          <Route path="*" element={<Navigate to={`/`} replace />} />
        </Routes>
      </Router>
    </div>
  );
};

export default PruffConnectRoutes;
